import { FC, useEffect, useRef, useState } from "react";
import ObjectTabsLayout from "components/common/objects/ObjectTabsLayout/ObjectTabsLayout";

// Data
import { useAppDispatch, useAppSelector } from "hooks";
import {
  selectDrawerSelectedAccountId,
  selectSpecificObjectState
} from "app/data/selectors";
import { useNavigate } from "react-router-dom";
import ObjectMonitoringSection from "components/sections/objects/ObjectMonitoringSection/ObjectMonitoringSection";

const ObjectMonitoring: FC = () => {
  const navigate = useNavigate();

  // Global State
  const drawerSelectedAccountId =
    useAppSelector(selectDrawerSelectedAccountId) || "";
  const { specificObject } = useAppSelector(selectSpecificObjectState);
  const [selectAccountId, setSelectedAccountId] = useState(
    drawerSelectedAccountId
  );

  useEffect(() => {
    if (drawerSelectedAccountId !== selectAccountId) {
      setSelectedAccountId(drawerSelectedAccountId);
      navigate("/dashboard/objects");
    }
  }, [drawerSelectedAccountId]);

  return (
    <main>
      <ObjectTabsLayout>
        <ObjectMonitoringSection specificObject={specificObject} />
      </ObjectTabsLayout>
    </main>
  );
};

export default ObjectMonitoring;
